import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Header from './header';
import { Icons } from "../../assest/icons";
import { logger } from '../../utils/logger';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import SideBarMenu from './sideBarMenu';
import { getAdmin, updateAdmin, ROLES, ROLE_LABELS, ADMIN_PORTAL_ROLES } from '../../services/firestore';
import { canManageAdminUsers } from '../../utils/roleHelper';




function AdminUserinfo() {
  const locationi = useLocation();
  // Fallback to logged-in user's ID for /admin/myprofile (no state passed)
  const loggedInAdminId = (() => { try { return JSON.parse(localStorage.getItem('UserIdAdmin')); } catch { return null; } })();
  const [userid, setuserid] = useState(locationi.state || loggedInAdminId);

  const [userProfileData, setUserProfileData] = useState([]);

  const [fullName, setFullName] = useState(userProfileData?.fullName || '');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState(userProfileData?.phoneNumber || '');
  const [userProfile, setUserProfile] = useState('');
  const [adminRole, setAdminRole] = useState(ROLES.ADMIN);
  const [specialty, setSpecialty] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [DOBTxt, setDOBTxt] = useState(userProfileData?.dob || '');
  const [InsuranceIdTxt, setInsuranceIdTxt] = useState(userProfileData?.insurance || '');
  const [GenderTxt, setGenderTxt] = useState(userProfileData?.gender || '');
  const [originalProfile, setOriginalProfile] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  var years = userProfileData?.dob ? moment().diff(moment(userProfileData.dob, ['YYYY-MM-DD', 'DD-MM-YYYY']), 'years') : 0;
  const ageCal = DOBTxt ? moment().diff(moment(DOBTxt, ['YYYY-MM-DD', 'DD-MM-YYYY']), 'years') : 0;
  const parseDOBToDate = (dob) => {
    if (!dob) return null;
    const m = moment(dob, ['YYYY-MM-DD', 'DD-MM-YYYY']);
    return m.isValid() ? m.toDate() : null;
  };

  const [AgeTxt, setAgeTxt] = useState(ageCal);
  const [WeightTxt, setWeightTxt] = useState(userProfileData?.weight || 0);
  const [HeightTxt, setHeightTxt] = useState(userProfileData?.height || 0);
  const [ShowLoader, setShowLoader] = useState(false);

  const [UserId, setUserId] = useState(userProfileData?.user_id || userProfileData?.id || '');
  const [showCalendar, setShowCalendar] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');

  // Signature state
  const [signatureUrl, setSignatureUrl] = useState('');
  const [isUploadingSignature, setIsUploadingSignature] = useState(false);
  const signatureInputRef = useRef(null);


  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const adminData = await getAdmin(userid);

        if (adminData) {
          setUserProfileData(adminData);
          setFullName(adminData.fullName || '');
          setEmail(adminData.email || '');
          setDOBTxt(adminData.dob || '');
          setPhoneNumber(adminData.phoneNumber || '');
          setUserProfile(adminData.userProfile || '');
          setAdminRole(adminData.role || ROLES.ADMIN);
          setSpecialty(adminData.specialty || '');
          setGenderTxt(adminData.gender || '');
          setSignatureUrl(adminData.signatureUrl || '');
        }
      } catch (error) {
        logger.error('Error fetching admin data:', error);
      }
    };
    fetchRecords();
  }, []);




  const onChangeCalendar = (date) => {
    setDOBTxt(formatDate(date));
    setShowCalendar(false);
};
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
};
const formatDate = (date) => {
  return date ? moment(date).format("YYYY-MM-DD") : '';
};
  const handleChangeCancel = () => {
    setIsEditing(!isEditing);
};
const handleGenderChange = (event) => {
  let { value } = event.target;
      // Allow delete action
      if (value === '') {
        setGenderTxt('');
    }
    // Convert input to uppercase for comparison
    value = value.toUpperCase();
  // Allow 'M', 'F', or 'O' characters
  if ( value === 'M' || value === 'F' || value === 'O') {
      setGenderTxt(value === 'M' ? 'Male' : value === 'F' ? 'Female' : 'Other');
  }
};

const handleChange = (e) => {
  const { name, value } = e.target;

};

const handlePhoneChange = (value) => {
  // Limit to US phone: country code (1 digit) + 10-digit number = 11 digits max
  const digits = (value || '').replace(/\D/g, '');
  if (digits.length <= 11) {
    setPhoneNumber(value);
  }
};

const handleSubmitProfile = async (event) => {

 event.preventDefault();
  // Simple form validation
  let formErrors = {};
  if (!phoneNumber.trim()) {
    formErrors.phoneNumber = 'Please enter your phone number';
  } else if (phoneNumber.replace(/\D/g, '').length < 10) {
    formErrors.phoneNumber = 'Please enter a valid phone number (at least 10 digits)';
  } else if (phoneNumber.replace(/\D/g, '').length > 11) {
    formErrors.phoneNumber = 'Please enter a valid 10-digit US phone number';
  }
  if (!DOBTxt || (typeof DOBTxt === 'string' && DOBTxt.trim().length === 0)) {
    formErrors.DOBTxt = 'Please select a date of birth';
  } else {
    const dobMoment = moment(DOBTxt, ['YYYY-MM-DD', 'DD-MM-YYYY']);
    if (!dobMoment.isValid()) {
      formErrors.DOBTxt = 'Invalid date format';
    } else if (dobMoment.isAfter(moment(), 'day')) {
      formErrors.DOBTxt = 'Date of birth cannot be in the future';
    } else if (moment().diff(dobMoment, 'years') < 18) {
      formErrors.DOBTxt = 'You must be at least 18 years old';
    }
  }
  if (!GenderTxt.trim()) {
      formErrors.GenderTxt = 'Please enter your sex';
  }
  if (!specialty.trim()) {
      formErrors.specialty = 'Please enter your specialty';
  }
  if (Object.keys(formErrors).length > 0) {
      setError(formErrors);
      return;
  }
  setShowLoader(true)
  // If validation passes, send data to API
  const dataReq = {
    phoneNumber: phoneNumber,
    dob: DOBTxt,
    gender:GenderTxt,
    specialty: specialty,
    user_id: userid,
    email:email,
    fullName:fullName,
    age:ageCal,
};
  // Only admin can change role
  if (canManageAdminUsers()) {
    dataReq.role = adminRole;
  }
try {
  await updateAdmin(userid, dataReq);

  const updatedAdmin = await getAdmin(userid);

  toast.success("Admin profile updated successfully!", {
    position: toast.POSITION.TOP_RIGHT,
  });

  localStorage.setItem('UserProfileAdmin', JSON.stringify(updatedAdmin));
  setShowLoader(false);
  setError('');
  handleCancel();

} catch (error) {
  logger.error('Error updating admin:', error);
  toast.error('Failed to update admin profile', {
    position: toast.POSITION.TOP_RIGHT,
  });
  setError('');
  setShowLoader(false);
}
};

// ── Signature Upload ──────────────────────────────────────────
// Resize image on canvas → JPEG base64 → save to Firestore directly.
// This avoids Firebase Storage permission issues entirely.
const resizeImageToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const MAX_W = 400;
    const MAX_H = 150;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        let w = img.width;
        let h = img.height;
        if (w > MAX_W) { h = Math.round(h * MAX_W / w); w = MAX_W; }
        if (h > MAX_H) { w = Math.round(w * MAX_H / h); h = MAX_H; }
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = ev.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const handleSignatureFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
  if (!allowed.includes(file.type)) {
    toast.error('Please upload a PNG, JPG or GIF image.', { position: toast.POSITION.TOP_RIGHT });
    return;
  }
  if (file.size > 5 * 1024 * 1024) {
    toast.error('Image must be under 5 MB.', { position: toast.POSITION.TOP_RIGHT });
    return;
  }

  setIsUploadingSignature(true);
  try {
    // Resize + compress to base64 (no Storage needed)
    const base64 = await resizeImageToBase64(file);

    // Save base64 directly to Firestore
    await updateAdmin(userid, { signatureUrl: base64 });

    // Update localStorage so viewpatient.js picks it up immediately
    const existing = JSON.parse(localStorage.getItem('UserProfileAdmin') || '{}');
    localStorage.setItem('UserProfileAdmin', JSON.stringify({ ...existing, signatureUrl: base64 }));

    setSignatureUrl(base64);
    toast.success('Signature uploaded successfully!', { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    logger.error('Error saving signature:', err);
    toast.error('Failed to save signature.', { position: toast.POSITION.TOP_RIGHT });
  } finally {
    setIsUploadingSignature(false);
    if (signatureInputRef.current) signatureInputRef.current.value = '';
  }
};

const handleRemoveSignature = async () => {
  if (!window.confirm('Remove your signature?')) return;
  try {
    await updateAdmin(userid, { signatureUrl: '' });
    const existing = JSON.parse(localStorage.getItem('UserProfileAdmin') || '{}');
    localStorage.setItem('UserProfileAdmin', JSON.stringify({ ...existing, signatureUrl: '' }));
    setSignatureUrl('');
    toast.success('Signature removed.', { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    toast.error('Failed to remove signature.', { position: toast.POSITION.TOP_RIGHT });
  }
};
// ─────────────────────────────────────────────────────────────


const handleCancel = () => {
  setIsEditing(false);
  setError('')
};

const handleFullNameChange = (event) => {
  // Remove non-text characters from the input value
  const value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  setFullName(value);
};

const normalizeEmail = (value) => (value || '').trim().toLowerCase();
const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);


  return (
    <div>
    <div className='container-fluid p-0 adminDashboardMain'>
      <SideBarMenu/>

      <div className='container-fluid p-0 contentBody'>
           <Header />
           <div className="innerBodyBox bgInnerDiv">

            <div className="contentInnerBody">
        <div className=' p-0    '>
        <div className='loginBoxDiv ForgotPassswordMain UserProfileMain whiteBgColor centerDivAlign addAdminUser'>
        <h2>Admin Details    <button className={'editIcon ' + (isEditing ?  'btnactive' : '') } onClick={() => setIsEditing(true)}>Edit
           <img src={isEditing ? Icons[0].editRed : Icons[0].editIcon } className="logoImg" alt="" />
           </button>
        </h2>

        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'profile' ? 'active' : ''}`}
              onClick={() => setActiveTab('profile')}
            >
              Profile
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'signature' ? 'active' : ''}`}
              onClick={() => setActiveTab('signature')}
            >
              Signature
            </button>
          </li>
        </ul>

       {activeTab === 'profile' && (
       <form onSubmit={handleSubmitProfile}>
       <fieldset className='editUserProfile'  id="sign_up" >
          <div className='inputDivBox' >
            <label>Full Name:</label>
              <div className={"inputTxtBox registerInputDiv  disabled"}>
                    <img src={Icons[0].userImg} className="logoImg" alt="" />
                    <input type="text" value={fullName} placeholder="Full Name" onChange={handleFullNameChange} readOnly />
            </div>
          </div>
          <div className='inputDivBox' >
            <label>Email:</label>
             <div className={"inputTxtBox registerInputDiv disabled"}>
                    <img src={Icons[0].mailImg} className="logoImg" alt="" />
                    <input type="text" value={email} placeholder="Email id"  onChange={handleChange}  readOnly />
                  </div>
          </div>
          <div className='inputDivBox' >
            <label>Phone Number:</label>
            <div className={"registerInputDiv "+ (isEditing ? '' : 'disabled')}>
                    <PhoneInput
                      autocomplete="off"
                      defaultCountry="US"
                      country={"us"}
                     id="phone"
                     placeholder="Enter phone number"
                     value={phoneNumber}
                     onChange={handlePhoneChange}
                     international={false}
                     onBlur={() => setIsValid(!!phoneNumber.trim())}
                     inputProps={{
                       name: 'phone',
                       required: true,
                       autoFocus: true,
                       autoComplete: 'off',
                     }}
                     disabled={isEditing ? '' : 'true'}
                    />
                  </div>
                  {error.phoneNumber && <span  className="errorTxt" >{error.phoneNumber}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Date of Birth:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                        <img src={Icons[0].dateIcon} className="logoImg" alt="" />
                        <input type="text"    value={DOBTxt} placeholder="Date of Birth (YYYY-MM-DD)" readOnly />
                        <button type="button" className={"toggleCalendarBtn " + (isEditing ? '' : 'd-none')}  disabled={isEditing ? '' : 'true'}  onClick={toggleCalendar}> <img src={Icons[0].calendarIcon} className="logoImg" alt="" /></button>
                          {showCalendar && (
                              <Calendar
                                className= 'inputCaledar'
                                onChange={onChangeCalendar}
                                value={parseDOBToDate(DOBTxt)}
                                maxDate={moment().subtract(18, 'years').toDate()}
                                minDate={moment().subtract(100, 'years').toDate()}
                              />
                          )}
                  </div>
                  {error.DOBTxt && <span  className="errorTxt" >{error.DOBTxt}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Specialty:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    <img src={Icons[0].InsuranceIDIcon} className="logoImg" alt="" />
                    <input type="text" value={specialty} placeholder="Specialty"  disabled={isEditing ? '' : 'true'} onChange={(e) => setSpecialty(e.target.value)}  />
                  </div>
                  {error.specialty && <span  className="errorTxt" >{error.specialty}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Gender:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                        <img src={Icons[0].GenderImg} className="logoImg" alt="" />
                        <input type="text" value={GenderTxt} placeholder="Sex" onChange={handleGenderChange} maxLength="1"     disabled={isEditing ? '' : 'true'}
                        onKeyUp={(e) => { if (e.key === 'Backspace') { setGenderTxt('');  } }}/>
            </div>
            {error.GenderTxt && <span  className="errorTxt" >{error.GenderTxt}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Role:</label>
            <div className={"inputTxtBox registerInputDiv " + ((isEditing && canManageAdminUsers()) ? '' : 'disabled')}>
              <img src={Icons[0].admin_adminIcon} className="logoImg" alt="" />
              {(isEditing && canManageAdminUsers()) ? (
                <select value={adminRole} onChange={(e) => setAdminRole(e.target.value)} style={{ fontSize: '16px', background: 'transparent', border: 0, width: 'calc(100% - 60px)', position: 'absolute', right: '10px', cursor: 'pointer', appearance: 'auto' }}>
                  {Object.entries(ADMIN_PORTAL_ROLES).map(([value, label]) => (
                    <option key={value} value={value}>{label}</option>
                  ))}
                </select>
              ) : (
                <input type="text" value={ROLE_LABELS[adminRole] || 'Admin'} readOnly disabled />
              )}
            </div>
          </div>


          </fieldset>
{
  isEditing ? (<>
  <div className={"saveOptDivBox "}>
          {ShowLoader ? (<>
                      <button  className="   " > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div>
                    </button>
                    </>):(<>
                      <button onClick={handleSubmitProfile} type="submit" >Save</button>
                    </>)}
                  <button type="button" onClick={handleCancel}>Cancel</button>
            </div>
  </>) : ('')
}

        </form>
        )}

        {/* ── Signature Tab ── */}
        {activeTab === 'signature' && (
          <div style={{ padding: '10px 0' }}>
            <p style={{ fontSize: '13px', color: '#666', marginBottom: '20px' }}>
              Upload your signature image (PNG, JPG, GIF — max 2 MB). This will appear on the Final Consultant Note and downloaded PDF reports.
            </p>

            {/* Current signature preview */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontWeight: '600', fontSize: '13px', display: 'block', marginBottom: '8px' }}>Current Signature</label>
              {signatureUrl ? (
                <div style={{ border: '1px solid #dee2e6', borderRadius: '8px', padding: '16px', display: 'inline-block', background: '#fafafa', minWidth: '260px' }}>
                  <img
                    src={signatureUrl}
                    alt="Provider Signature"
                    style={{ maxHeight: '80px', maxWidth: '320px', display: 'block', objectFit: 'contain' }}
                  />
                </div>
              ) : (
                <div style={{ border: '1.5px dashed #ccc', borderRadius: '8px', padding: '24px 32px', display: 'inline-block', color: '#aaa', fontSize: '13px' }}>
                  No signature uploaded yet
                </div>
              )}
            </div>

            {/* Upload button */}
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <input
                ref={signatureInputRef}
                type="file"
                accept="image/png,image/jpeg,image/jpg,image/gif"
                style={{ display: 'none' }}
                onChange={handleSignatureFileChange}
              />
              <button
                type="button"
                onClick={() => signatureInputRef.current && signatureInputRef.current.click()}
                disabled={isUploadingSignature}
                style={{
                  padding: '8px 20px',
                  background: '#024C9C',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '600',
                  cursor: isUploadingSignature ? 'not-allowed' : 'pointer',
                  opacity: isUploadingSignature ? 0.7 : 1,
                }}
              >
                {isUploadingSignature ? (
                  <>
                    <span className="spinner-border spinner-border-sm text-light" role="status" style={{ marginRight: '6px' }} />
                    Uploading...
                  </>
                ) : (
                  signatureUrl ? 'Replace Signature' : 'Upload Signature'
                )}
              </button>

              {signatureUrl && (
                <button
                  type="button"
                  onClick={handleRemoveSignature}
                  style={{
                    padding: '8px 16px',
                    background: '#fff',
                    color: '#dc3545',
                    border: '1px solid #dc3545',
                    borderRadius: '6px',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Remove
                </button>
              )}
            </div>

            <p style={{ fontSize: '11px', color: '#999', marginTop: '12px' }}>
              Tip: Use a white or transparent background image for best results in PDF reports.
            </p>
          </div>
        )}


      </div>
         </div>
    </div>
    </div>
    </div>
         </div>
    </div>
  );
}

export default AdminUserinfo;
